import { Link } from '@remix-run/react'

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			{/* TODO: Add Meta */}
			{/* <Helmet
      title="Stanley O Steele Jr"
      meta={[
        {
          name: "description",
          content:
            "Learn about this local family-man and founder of the Stan Steele Agency.",
        },
        {
          name: "keywords",
          content: "Stanley O Steele Jr",
        },
      ]}
    /> */}
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link
				to="/about-us/"
				className="text-blue-600 underline"
				prefetch="intent"
			>
				About Us
			</Link>
			<br />
			<br />
			<h1 className="text-4xl font-black">Stanley O Steele Jr</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Stan Steele was a farmer and enjoyed helping others. He was involved in
				many businesses throughout his life and also enjoyed volunteering in the
				community. He got his start in insurance when he was a young farmer. He
				needed to protect his farm and learned about different options for
				insurance. He then helped his friends and neighbors in the community and
				became the go-to insurance man in the area. He became a captive
				insurance agent selling insurance for{' '}
				<Link
					to="/our-insurance-company-relationships/farm-family/"
					className="text-blue-600 underline"
					prefetch="intent"
				>
					Farm Family Insurance Company
				</Link>{' '}
				and helped to build up that company in New York State. After several
				years he realized that he could better serve the needs of his clients by
				offering insurance plans from a variety of insurance companies. He
				decided to become an independent agent and quickly secured contracts
				with many insurers.
			</p>
		</main>
	)
}
